import React from "react";
import styled from "styled-components";
import { ReactComponent as SelectedCheckbox } from "../../atoms/icons/checkboxes-selected.svg";
import { ReactComponent as QuestionMark } from "../../atoms/icons/question-mark.svg";

const Wrap = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 16px;
    padding: 10px 0 15px 0;
    border-top: 1px solid #e6e6e6;
`;

const Input = styled.input`
    display: none;

    &:checked + label {
        &::after {
            opacity: 1;
        }

        &::before {
            opacity: 0;
        }

        > svg {
            opacity: 1;
        }
    }

    & + label > svg {
        position: absolute;
        top: 0;
        left: 1px;
        width: 16px;
        height: 16px;
        background: #979797;
        border-radius: 3px;
        opacity: 0;
    }
`;

const Label = styled.label`
    position: relative;
    padding-left: 30px;
    font-size: 14px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    user-select: none;
    cursor: pointer;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 1px;
        width: 16px;
        height: 16px;
        border-radius: 3px;
        border: solid 2px #979797;
    }
`;

const Question = styled.div`
    position: relative;
    cursor: pointer;

    &:hover div {
        opacity: 1;
        visibility: visible;
        transition: 0.3s ease all;
    }

    svg {
        margin-top: 5px;
    }
`;

const Tooltip = styled.div`
    opacity: 0;
    visibility: hidden;
    width: 125px;
    position: absolute;
    z-index: 2;
    transform: translate(0, -50%);
    top: 50%;
    right: 28px;
    padding: 8px 16px;
    border-radius: 4px;
    background: #5c5c5c;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: normal;
    text-align: left;
    color: #fff;
    transition: 0.3s ease all;

    &::after {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        transform: translate(0, -50%);
        top: 50%;
        left: 100%;
        border-style: solid;
        border-width: 5px 0 5px 5px;
        border-color: transparent transparent transparent #5c5c5c;
    }
`;

function DietitianSupport(props) {
    return props.dietitian.id.length ? (
        <Wrap>
            <Input
                id="dt-sp"
                type="checkbox"
                checked={props.dietitian.support}
                value={props.dietitian.id}
                onChange={(e) => props.handleDietitianChange(e.target)}
            />
            <Label htmlFor="dt-sp">
                Include Dietitian Support
                <SelectedCheckbox />
            </Label>
            <Question>
                <Tooltip>
                    You have the option to include dietitian support from our
                    GI-trained dietitians for a low, one-time fee $99.00
                </Tooltip>
                <QuestionMark />
            </Question>
        </Wrap>
    ) : null;
}

export default DietitianSupport;
